/** Standard apparel size order (platform constant `order.apparel_sizes`). */
const ORDER = ["2XS", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];

const rank = (size: string) => {
  const i = ORDER.indexOf(size.toUpperCase());
  return i === -1 ? ORDER.length : i;
};

/** Comparator for size labels in standard order; unknown sizes last. */
export const bySizeOrder = (a: string, b: string) => rank(a) - rank(b);

/** The same sizes, keyed in standard order (JSON from the API arrives alphabetic). Unknown sizes go last. */
export function inSizeOrder<T>(sizes: Record<string, T>): Record<string, T> {
  return Object.fromEntries(Object.entries(sizes).sort(([a], [b]) => bySizeOrder(a, b)));
}
